import React from 'react';
import { FileText, Download } from 'lucide-react';
import { BlockShell, ci, safeUrl } from './_shared';

// Dokumente: Liste mit Typ-Icon, Titel, Format/Größe, Download-Aktion.
const BlockDocuments = ({ dto, t, isDarkMode }) => {
  const docs = dto.documents || {};
  const c = ci(isDarkMode);
  const items = docs.items || [];

  return (
    <BlockShell title={t('productDetail.documents')} icon={FileText} status={docs.status} isDarkMode={isDarkMode} demoLabel={t('productDetail.demoFromSap')}>
      <div className={`divide-y ${isDarkMode ? 'divide-white/10' : 'divide-slate-100'}`}>
        {items.map((d, i) => (
          <div key={i} className="flex items-center justify-between py-2">
            <span className="flex items-center gap-2 min-w-0">
              <FileText className={`w-4 h-4 flex-shrink-0 ${isDarkMode ? 'text-white/50' : 'text-slate-400'}`} />
              <span className={`text-sm truncate ${c.value}`}>{d.title}</span>
              <span className={`text-xs ${c.label}`}>{d.fileFormat}{d.sizeMb ? ` · ${d.sizeMb} MB` : ''}</span>
            </span>
            <a
              href={safeUrl(d.url) || undefined}
              className="inline-flex items-center gap-1 text-xs text-brand hover:underline flex-shrink-0"
              onClick={(e) => { if (!safeUrl(d.url)) e.preventDefault(); }}
            >
              <Download className="w-3.5 h-3.5" /> {t('productDetail.download')}
            </a>
          </div>
        ))}
      </div>
    </BlockShell>
  );
};

export default BlockDocuments;
